import { AutomatonPreset } from './types'

// 1 = ◢
// 2 = ◣
// 3 = ◥
// 4 = ◤

export const flippy: AutomatonPreset = {
  name: 'Flippy',
  rules: [
    {
      conditions: [
        { n: [0, -1], value: 1 },
        { n: [0, -2], value: 3 }
      ],
      result: 2
    },
    {
      conditions: [
        { n: [0, -1], value: 3 },
        { n: [0, -2], value: 1 }
      ],
      result: 4
    },
    {
      conditions: [
        { n: [0, -1], value: 4 },
        { n: [0, -2], value: 2 }
      ],
      result: 3
    },
    {
      conditions: [
        { n: [0, -1], value: 2 },
        { n: [0, -2], value: 4 }
      ],
      result: 1
    },
    //
    {
      conditions: [
        { n: [-1, 0], value: 2 },
        { n: [-2, 0], value: 4 }
      ],
      result: 1
    },
    {
      conditions: [
        { n: [-1, 0], value: 3 },
        { n: [-2, 0], value: 4 }
      ],
      result: 1
    },

    {
      conditions: [
        { n: [-1, 0], value: 1 },
        { n: [-2, 0], value: 3 }
      ],
      result: 2
    },
    {
      conditions: [
        { n: [-1, 0], value: 4 },
        { n: [-2, 0], value: 3 }
      ],
      result: 2
    },

    {
      conditions: [
        { n: [-1, 0], value: 4 },
        { n: [-2, 0], value: 2 }
      ],
      result: 3
    },
    {
      conditions: [
        { n: [-1, 0], value: 1 },
        { n: [-2, 0], value: 2 }
      ],
      result: 3
    },
    {
      conditions: [
        { n: [-1, 0], value: 3 },
        { n: [-2, 0], value: 1 }
      ],
      result: 4
    },
    {
      conditions: [
        { n: [-1, 0], value: 2 },
        { n: [-2, 0], value: 1 }
      ],
      result: 4
    },
    {
      conditions: [
        { n: [0, -1], value: 3 },
        { n: [0, -2], value: 4 }
      ],
      result: 1
    },
    {
      conditions: [
        { n: [0, -1], value: 2 },
        { n: [0, -2], value: 1 }
      ],
      result: 4
    },
    {
      conditions: [
        { n: [0, 1], value: 1 },
        { n: [0, 2], value: 3 }
      ],
      result: 2
    },
    {
      conditions: [
        { n: [-1, 0], value: 3 },
        { n: [0, 0], value: 0 },
        { n: [0, 1], value: 0 },
        { n: [0, -1], value: 0 }
      ],
      result: 4
    }
  ]
}

const simple: AutomatonPreset = {
  name: 'Simple',
  rules: [
    {
      conditions: [
        { n: [0, -1], value: 2 },
        { n: [1, 0], value: 2 },
        { n: [0, 0], value: 2 }
      ],
      result: 3
    },
    {
      conditions: [
        { n: [0, -1], value: 1 },
        { n: [-1, 0], value: 1 },
        { n: [0, 0], value: 1 }
      ],
      result: 4
    },
    {
      conditions: [
        { n: [0, 1], value: 4 },
        { n: [1, 0], value: 4 },
        { n: [0, 0], value: 4 }
      ],
      result: 1
    },
    {
      conditions: [
        { n: [0, 1], value: 3 },
        { n: [-1, 0], value: 3 },
        { n: [0, 0], value: 3 }
      ],
      result: 1
    }
  ]
}

const another2: AutomatonPreset = {
  name: 'Another 2',
  rules: [
    {
      conditions: [
        { n: [-1, 0], value: 4 },
        { n: [-2, 0], value: 3 }
      ],
      result: 1
    },
    {
      conditions: [
        { n: [1, 0], value: 1 },
        { n: [2, 0], value: 2 }
      ],
      result: 4
    },
    {
      conditions: [
        { n: [0, 1], value: 1 },
        { n: [0, 2], value: 3 }
      ],
      result: 4
    }
  ]
}
const lozenges: AutomatonPreset = {
  name: 'Lozenges',
  rules: [
    {
      conditions: [
        { n: [0, 1], value: 3 },
        { n: [1, 0], value: 2 },
        { n: [1, 1], value: 4 }
      ],
      result: 0
    },
    {
      conditions: [
        { n: [-1, 0], value: 1 },
        { n: [0, -1], value: 1 },
        { n: [1, -1], value: 1 }
      ],
      result: 0
    },
    {
      conditions: [
        { n: [1, 0], value: 2 },
        { n: [0, 1], value: 4 }
      ],
      result: 0
    },
    {
      conditions: [{ n: [-1, -1], value: 2 }],
      result: 2
    },
    {
      conditions: [
        { n: [0, -1], value: 2 },
        { n: [-1, -2], value: 2 }
      ],
      result: 4
    },
    {
      conditions: [{ n: [1, -1], value: 4 }],
      result: 4
    },
    {
      conditions: [
        { n: [1, 0], value: 4 },
        { n: [2, -1], value: 4 }
      ],
      result: 3
    },
    {
      conditions: [
        { n: [1, 1], value: 3 },
        { n: [2, 1], value: 4 }
      ],
      result: 3
    },
    {
      conditions: [
        { n: [0, 1], value: 3 },
        { n: [1, 2], value: 3 }
      ],
      result: 1
    },
    {
      conditions: [
        { n: [-1, 1], value: 1 },
        { n: [-1, 2], value: 3 }
      ],
      result: 1
    }
  ]
}

const arrows: AutomatonPreset = {
  name: 'Arrows',
  rules: [
    {
      conditions: [
        {
          n: [-1, 1],
          value: 4
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, 1],
          value: 2
        }
      ],
      result: 4
    },
    {
      conditions: [
        {
          n: [-1, -1],
          value: 2
        },
        {
          n: [-1, 0],
          value: 3
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, -1],
          value: 3
        },
        {
          n: [0, 1],
          value: 2
        }
      ],
      result: 3
    }
  ]
}

const confetti: AutomatonPreset = {
  name: 'Confetti',
  rules: [
    {
      conditions: [{ n: [0, 1], value: 1 }],
      result: 3
    },
    {
      conditions: [{ n: [0, 1], value: 2 }],
      result: 4
    },
    {
      conditions: [{ n: [0, 1], value: 3 }],
      result: 2
    },
    {
      conditions: [{ n: [0, 1], value: 4 }],
      result: 1
    }
  ]
}

const prettyLines: AutomatonPreset = {
  name: 'Pretty Lines',
  rules: [
    {
      conditions: [
        {
          n: [-1, 1],
          value: 1
        },
        {
          n: [1, 0],
          value: 2
        }
      ],
      result: 1
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 4
        },
        {
          n: [0, -1],
          value: 4
        },
        {
          n: [1, 1],
          value: 3
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [-1, 1],
          value: 2
        },
        {
          n: [0, -1],
          value: 2
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [1, 1],
          value: 3
        },
        {
          n: [1, 1],
          value: 1
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [1, -1],
          value: 2
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 1
        },
        {
          n: [1, -1],
          value: 3
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [-1, -1],
          value: 3
        },
        {
          n: [0, -1],
          value: 2
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 2
        }
      ],
      result: 4
    },
    {
      conditions: [
        {
          n: [-1, 0],
          value: 3
        },
        {
          n: [1, 0],
          value: 2
        }
      ],
      result: 1
    }
  ]
}

const weaving: AutomatonPreset = {
  name: 'Weaving',
  rules: [
    {
      conditions: [
        {
          n: [1, -1],
          value: 3
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [0, 1],
          value: 3
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [-1, 1],
          value: 1
        },
        {
          n: [1, -1],
          value: 2
        },
        {
          n: [1, 1],
          value: 2
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 4
        },
        {
          n: [1, -1],
          value: 4
        }
      ],
      result: 1
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 3
        }
      ],
      result: 4
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 3
        },
        {
          n: [-1, 0],
          value: 3
        },
        {
          n: [0, -1],
          value: 2
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [-1, -1],
          value: 3
        },
        {
          n: [-1, 0],
          value: 4
        }
      ],
      result: 1
    },
    {
      conditions: [
        {
          n: [1, 1],
          value: 2
        },
        {
          n: [0, -1],
          value: 3
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 1
        },
        {
          n: [1, 0],
          value: 4
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 4
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, -1],
          value: 4
        },
        {
          n: [0, 1],
          value: 3
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [0, 1],
          value: 2
        },
        {
          n: [0, 1],
          value: 2
        }
      ],
      result: 3
    }
  ]
}
const lines: AutomatonPreset = {
  name: 'Lines',
  rules: [
    {
      conditions: [
        {
          n: [-1, 1],
          value: 3
        },
        {
          n: [0, -1],
          value: 3
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 3
        },
        {
          n: [-1, -1],
          value: 3
        }
      ],
      result: 4
    },
    {
      conditions: [
        {
          n: [-1, -1],
          value: 2
        },
        {
          n: [-1, 0],
          value: 2
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [-1, 1],
          value: 2
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [0, 1],
          value: 3
        },
        {
          n: [-1, 1],
          value: 1
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 1
        },
        {
          n: [1, -1],
          value: 2
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 3
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 3
        },
        {
          n: [1, 1],
          value: 2
        }
      ],
      result: 4
    },
    {
      conditions: [
        {
          n: [-1, -1],
          value: 1
        },
        {
          n: [0, -1],
          value: 2
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [-1, 1],
          value: 3
        },
        {
          n: [1, -1],
          value: 2
        }
      ],
      result: 3
    }
  ]
}

const infiniteWiggle: AutomatonPreset = {
  name: 'Infinite Wiggle',
  rules: [
    {
      conditions: [
        {
          n: [-1, 1],
          value: 4
        },
        {
          n: [-1, -1],
          value: 4
        }
      ],
      result: 4
    },
    {
      conditions: [
        {
          n: [0, 1],
          value: 2
        },
        {
          n: [0, -1],
          value: 3
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 3
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, 1],
          value: 2
        }
      ],
      result: 4
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 4
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 1
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 4
        },
        {
          n: [-1, 0],
          value: 1
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [0, 1],
          value: 3
        },
        {
          n: [-1, 1],
          value: 2
        }
      ],
      result: 1
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 2
        },
        {
          n: [-1, 0],
          value: 4
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [0, 1],
          value: 1
        },
        {
          n: [1, -1],
          value: 3
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 4
        },
        {
          n: [1, 0],
          value: 1
        }
      ],
      result: 3
    }
  ]
}

// 1 = ◢
// 2 = ◣
// 3 = ◥
// 4 = ◤
const maybe: AutomatonPreset = {
  name: 'Maybe',
  rules: [
    {
      conditions: [
        {
          n: [0, -1],
          value: 2
        },
        {
          n: [1, -1],
          value: 3
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 3
        },
        {
          n: [1, 1],
          value: 1
        }
      ],
      result: 4
    },
    {
      conditions: [
        {
          n: [0, 1],
          value: 1
        },
        {
          n: [-1, 1],
          value: 1
        },
        {
          n: [-1, 0],
          value: 3
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 1
        },
        {
          n: [0, -1],
          value: 2
        },
        {
          n: [-1, 0],
          value: 2
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [-1, -1],
          value: 2
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, -1],
          value: 3
        },
        {
          n: [0, 1],
          value: 2
        },
        {
          n: [1, -1],
          value: 4
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [0, -1],
          value: 4
        },
        {
          n: [-1, 1],
          value: 2
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [0, 1],
          value: 3
        },
        {
          n: [1, 1],
          value: 4
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, -1],
          value: 3
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [1, 0],
          value: 4
        }
      ],
      result: 2
    },
    {
      conditions: [
        {
          n: [1, -1],
          value: 3
        }
      ],
      result: 3
    },
    {
      conditions: [
        {
          n: [1, 1],
          value: 4
        },
        {
          n: [0, -1],
          value: 3
        }
      ],
      result: 4
    },
    {
      conditions: [
        {
          n: [1, -1],
          value: 3
        }
      ],
      result: 3
    }
  ]
}
const tokens: AutomatonPreset = {
  name: 'tokens',
  rules: [
    {
      conditions: [
        { n: [-1, 0], value: 2 },
        { n: [0, -1], value: 3 }
      ],
      result: 1
    },
    {
      conditions: [
        { n: [1, 0], value: 3 },
        { n: [1, 1], value: 1 }
      ],
      result: 4
    },
    {
      conditions: [{ n: [1, 0], value: 1 }],
      result: 2
    },
    {
      conditions: [{ n: [-1, -1], value: 4 }],
      result: 1
    },
    {
      conditions: [
        { n: [1, -1], value: 2 },
        { n: [1, 0], value: 4 }
      ],
      result: 3
    },
    {
      conditions: [{ n: [0, 1], value: 1 }],
      result: 3
    },
    {
      conditions: [{ n: [0, -1], value: 3 }],
      result: 1
    },
    {
      conditions: [
        { n: [1, 0], value: 2 },
        { n: [1, 1], value: 4 },
        { n: [0, 1], value: 3 }
      ],
      result: 1
    },
    {
      conditions: [{ n: [-1, 1], value: 4 }],
      result: 4
    }
  ]
}

// 1 = ◢
// 2 = ◣
// 3 = ◥
// 4 = ◤

export const reduce: AutomatonPreset = {
  name: 'Reducer',
  rules: [
    {
      conditions: [
        { n: [-1, 0], value: 1 },
        { n: [-2, 0], value: 0 }
      ],
      result: 2
    },
    {
      conditions: [
        { n: [-1, 0], value: 3 },
        { n: [-2, 0], value: 0 }
      ],
      result: 4
    },
    {
      conditions: [
        { n: [1, 0], value: 2 },
        { n: [2, 0], value: 0 }
      ],
      result: 1
    },
    {
      conditions: [
        { n: [1, 0], value: 4 },
        { n: [2, 0], value: 0 }
      ],
      result: 3
    }
  ]
}

export const allAutomaton: AutomatonPreset[] = [
  tokens,
  maybe,
  infiniteWiggle,
  lines,
  weaving,
  prettyLines,
  arrows,
  confetti,
  lozenges,
  another2,
  simple,
  flippy,
  reduce
]
